import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Bio from "./components/Bio";
import Acting from "./components/Acting";
import Directing from "./components/Directing";
import Education from "./components/Education";
import Resume from "./components/Resume";
import "./App.css";

function App() {
  const [panel, setPanel] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const renderPanel = () => {
    switch (panel) {
      case "acting":
        return <Acting />;
      case "directing":
        return <Directing />;
      case "education":
        return <Education />;
      case "resume":
        return <Resume />;
      default:
        return null;
    }
  };

  return (
    <div className="app">

      {/* TOP NAVBAR */}
      <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      {/* <div className={`sidebar ${menuOpen ? "open" : ""}`}></div> */}
      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      <div className="layout">

        {/* LEFT SIDEBAR TABS */}
        {/* <aside className="sidebar"> */}
        <aside className={`sidebar ${menuOpen ? "open" : ""}`}>
          <button onClick={() => { setPanel("directing"); setMenuOpen(false); }}>
            Directing
          </button>
          <button onClick={() => { setPanel("acting"); setMenuOpen(false); }}>
            Acting
          </button>
          <button onClick={() => { setPanel("education"); setMenuOpen(false); }}>
            Teaching
          </button>
          {/* <button onClick={() => { setPanel("resume"); setMenuOpen(false); }}>
            Resume/CV
          </button> */}
        </aside>

        {/* MAIN HOME CONTENT */}
        <main className="content">
          <Hero />
          <Bio />
        </main>

        {/* SLIDING PANEL */}
        <div className={`panel ${panel ? "open" : ""}`}>
          <button className="close-btn" onClick={() => setPanel(null)}>
            ✕
          </button>

          <div className="panel-content">
            {renderPanel()}
          </div>
        </div>

      </div>
    </div>
  );
}

export default App;